export default __webpack_public_path__ + "static/media/SBIGeneral.d70cef6d.svg";